import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(_ctx.rootClasses),
    style: _normalizeStyle(_ctx.rootStyle)
  }, [
    (!_ctx.useIconComponent)
      ? (_openBlock(), _createElementBlock("i", {
          key: 0,
          class: _normalizeClass([_ctx.newPack, _ctx.newIcon, _ctx.newCustomSize, _ctx.customClass])
        }, null, 2))
      : (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.useIconComponent), {
          key: 1,
          icon: [_ctx.newPack, _ctx.newIcon],
          size: _ctx.newCustomSize,
          class: _normalizeClass([_ctx.customClass])
        }, null, 8, ["icon", "size", "class"]))
  ], 6))
}